import UsersController from './users.controller.js';
import UsersEditController from './users-edit.controller.js';
import NewUserController from './new-user.controller.js';

import usersTpl from './users.html';
import usersEditTpl from './users.edit.html';
import usersNewTpl from './users.new.html';

export default function usersRouter($stateProvider) {
  $stateProvider
    .state('app.users', {
      url: '/users',
      templateUrl: usersTpl,
      controller: UsersController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['USER_READ'],
      },
    })
    .state('app.users.edit', {
      url: '/:userId/edit',
      templateUrl: usersEditTpl,
      controller: UsersEditController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['USER_UPDATE'],
      },
      params: {
        userId: null,
        user: null,
      },
    })
    .state('app.users.new', {
      url: '/users/new',
      templateUrl: usersNewTpl,
      controller: NewUserController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['USER_CREATE'],
      },
    });
}



// WEBPACK FOOTER //
// ./src/app/users/users.router.js